import { parseEmojiPickerUnified } from '@/lib/utils'
import { SkinTones } from 'emoji-picker-react'
import { getSuggested, setSuggested } from 'emoji-picker-react/src/dataUtils/suggested'
import FlexSearch from 'flexsearch'
import { atom, getDefaultStore } from 'jotai'
import { unwrappedUserEmojiListAtom } from '@/atoms/lists'
import { Emoji } from '@nostr/gadgets/lists'

const store = getDefaultStore()

export const emojiMapAtom = atom((get) => {
  const map = new Map<string, Emoji>()

  const emojiList = get(unwrappedUserEmojiListAtom)
  if (emojiList)
    for (const emoji of emojiList)
      if ('shortcode' in emoji) map.set(emoji.shortcode, emoji)
      else for (const e of emoji.items) map.set(e.shortcode, e)

  return map
})

const emojiIndexAtom = atom((get) => {
  const index = new FlexSearch.Index({
    tokenize: 'full'
  })

  const emojiList = get(unwrappedUserEmojiListAtom)
  if (emojiList)
    for (const emoji of emojiList)
      if ('shortcode' in emoji) index.add(emoji.shortcode, emoji.shortcode)
      else for (const e of emoji.items) index.add(e.shortcode, e.shortcode)

  return index
})

export function searchEmojis(query: string = ''): string[] {
  if (!query) {
    const idSet = new Set<string>()

    for (const item of getSuggested().sort((a, b) => b.count - a.count)) {
      const pitem = parseEmojiPickerUnified(item.unified)
      if (pitem && typeof pitem !== 'string') {
        if (!idSet.has(pitem.shortcode)) idSet.add(pitem.shortcode)
      }
    }

    const map = store.get(emojiMapAtom)
    for (const key of map.keys()) {
      idSet.add(key)
    }

    return Array.from(idSet)
  }

  const index = store.get(emojiIndexAtom)
  return index.search(query) as string[]
}

export function isCustomEmoji(shortcode: string): boolean {
  const map = store.get(emojiMapAtom)
  return map.has(shortcode)
}

export function getCustomEmoji(shortcode: string): Emoji | undefined {
  const map = store.get(emojiMapAtom)
  return map.get(shortcode)
}

export function getAllCustomEmojisForPicker() {
  const map = store.get(emojiMapAtom)

  return Array.from(map.values()).map((emoji) => ({
    id: `:${emoji.shortcode}:${emoji.url}`,
    imgUrl: emoji.url,
    names: [emoji.shortcode]
  }))
}

export function updateSuggested(id: string) {
  const emoji = store.get(emojiMapAtom).get(id)
  if (!emoji) return

  setSuggested(
    {
      n: [emoji.shortcode.toLowerCase()],
      u: `:${emoji.shortcode}:${emoji.url}`.toLowerCase(),
      a: '0',
      imgUrl: emoji.url
    },
    SkinTones.NEUTRAL
  )
}
